var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.shared
      ? _c("i", { staticClass: "far fa-check-square" })
      : _c("i", { staticClass: "far fa-square" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }